import type { components } from '@altyor/api-contract';

export type DisputeOutcome = components['schemas']['DisputeResolution']['outcome'];

export interface OutcomePresentation {
  labelFr: string;
  pillClass: string;
  emoji: string;
}

/**
 * Map a `DisputeResolution.outcome` enum value to its UI presentation. The
 * five enum values collapse into three visual buckets (accepted / refused /
 * withdrawn) since the inbound vs outbound flavour only matters to BE
 * routing — finance users see the same outcome regardless of direction.
 */
export function describeOutcome(outcome: DisputeOutcome): OutcomePresentation {
  switch (outcome) {
    case 'accepted_by_supplier':
    case 'accepted_by_buyer':
      return { labelFr: 'Litige accepté', pillClass: 'pill--success', emoji: '🤝' };
    case 'refused_by_supplier':
    case 'refused_by_buyer':
      return { labelFr: 'Litige refusé', pillClass: 'pill--danger', emoji: '❌' };
    case 'withdrawn':
      return { labelFr: 'Litige retiré', pillClass: 'pill--neutral', emoji: '🚩' };
  }
}
